module.exports = __webpack_public_path__ + "static/media/vip_room_3.82ef2553.png";